var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpireLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 24,
    viewBox: "0 0 57 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3787 14.0524H3.22678V19.7494H16.7175V22.4767H0V1.77539H16.6145V4.50266H3.2182V11.3598H15.6276V14.0524H15.3701H15.3787Z",
    fill: "#0F172A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5027 19.2735L29.3789 22.4856H35.206L35.412 22.2692L38.3298 19.2735L41.2476 16.2778L44.1655 13.2821L47.0833 10.2865L50.0011 7.2908L52.919 4.29513L55.3562 1.79297H49.5291L47.0919 4.29513L44.1741 7.2908L41.2562 10.2865L38.3384 13.2821L35.4206 16.2778L32.5027 19.2735ZM23.0541 18.2432V14.0008H31.3013V10.2518H26.7014L23.0541 14.0008H18.9262V22.4856H23.0455V18.2432H23.0541ZM18.9262 9.76699V10.2605H23.0455V5.53323H33.7042L35.412 7.2908H41.2391L38.3212 4.29513L35.884 1.79297H18.9091V9.77565H18.9262V9.76699ZM47.0833 19.2735L50.0011 22.2692L50.2071 22.4856H56.0342L52.9104 19.2735L49.9926 16.2778H44.1655L47.0833 19.2735Z",
    fill: "#3636F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpireLogoShort);
export default __webpack_public_path__ + "static/media/empire-logo-short.7af8f4a81cd435979a85336af6228e60.svg";
export { ForwardRef as ReactComponent };